export default __webpack_public_path__ + "static/media/user.532a1749.svg";